// extracted by mini-css-extract-plugin
module.exports = {"balloonTypeSection":"BalloonTypeSection_balloonTypeSection__1JCPQ","arrow":"BalloonTypeSection_arrow__1z9FN","imagesWrapper":"BalloonTypeSection_imagesWrapper__1aeil"};